export default "__VITE_ASSET__kX1SrNYu__"